import React from 'react';
import { Badge } from '../ui/badge';

type UserRole = 'system admin' | 'owner' | 'editor' | 'viewer' | string;

interface UserRoleBadgeProps {
  role: UserRole;
  className?: string;
}

/**
 * Maps user role to generic Badge variant
 */
const getRoleVariant = (role: string): 'destructive' | 'default' => {
  switch (role.toLowerCase()) {
    case 'system admin':
      return 'destructive';
    case 'owner':
    case 'editor':
    case 'viewer':
    default:
      return 'default';
  }
};

export const UserRoleBadge: React.FC<UserRoleBadgeProps> = ({ role, className = '' }) => {
  return (
    <Badge variant={getRoleVariant(role)} className={className}>
      {role}
    </Badge>
  );
};

export default UserRoleBadge;
